import React, { useEffect, useState } from 'react'
import CustomTable from '../../../../../Components/Table/CustomTable'
// import BannerinputGetModal from '../../Modal/BannerModal/BannerinputGetModaldal';
import { Grid } from '@mui/material';
// import BannerinputGetModal from '../../../CommonModal/BannerModal/BannerinputGetModal';
import { useDispatch, useSelector } from 'react-redux';
import actions from '../../../../../ReduxStore/actions';
import { toast } from 'react-toastify';
import BannerinputGetModal from '../../Modal/BannerinputGetModal';
import LandingPage from '../../Preview/LandingPage';
import PreviewComponent from '../../../PreviewComponent/PreviewComponent';
import { setHeaderName, setSubHeaderName } from '../../../../../ReduxStore/Slices/headerSlice';

const BannerHome = () => {

  const permissions = JSON.parse(sessionStorage.getItem("permissions"));
  // const permissions = JSON.parse(sessionStorage.getItem("permissions"));
  const role = sessionStorage.getItem("role")
  // csonole

  // const tableData = role === "superAdmin"
  //   ? [{ title: 'The Best Gold', secondtext: 'Staking Company', subtext: 'Lorem Ipsum is simply dummy text of the...', documents: "banner.jpg" }]
  //   : [];

  const tableHeadData = role === "superAdmin" || role==="management"
    ? ['S.No', 'Title', 'Second Text', 'Sub Text', 'Creater Name', "Creater Role", "Approver Name", "Approver Role", "Rejector Name", "Rejector Role", "status"]
    : ['S.No', 'Title', 'Second Text', 'Sub Text', 'status']





  const dispatch = useDispatch();

  const [responseTableData, setResponseTableData] = useState([])
  // const permissions = JSON.parse(sessionStorage.getItem("permissions"));
  console.log(responseTableData, "responseTableDataresponseTableData")
  const { getStakeNowSectionById } = useSelector(state => state?.getStakeNowSectionById);
  const { addStakeNowSectionPost } = useSelector(state => state?.addStakeNowSectionPost);

  const { updateStakeNowSection } = useSelector(
    (state) => state?.updateStakeNowSection
  );


  const { deleteStakeNowSection } = useSelector(
    (state) => state?.deleteStakeNowSection
  );


  const { addHomeSectionPost } = useSelector(
    (state) => state?.addHomeSectionPost
  );

  const { getAllHomeSectionsWithCreatorBySectionName } = useSelector(
    (state) => state?.getAllHomeSectionsWithCreatorBySectionName
  );

  const { getAllHomeSectionsBySectionNameBasedOnCreator } = useSelector(
    (state) => state?.getAllHomeSectionsBySectionNameBasedOnCreator
  );

  const [rowTableData, setRowTableData] = useState([])
  console.log(rowTableData, "rowTableTAdatatattattat")
  console.log(getAllHomeSectionsBySectionNameBasedOnCreator, "rowTableTAdatatattattat111111")

  const { addHomeSectionWithApproval } = useSelector(
    (state) => state?.addHomeSectionWithApproval
  );

  const { deleteHomeSection } = useSelector(
    (state) => state?.deleteHomeSection
  );

  const { updateHomeSection } = useSelector(
    (state) => state?.updateHomeSection
  );

  const { updateHomeSectionForReApproval } = useSelector(
    (state) => state?.updateHomeSectionForReApproval
  );

  const { getAllHomeSectionsBySectionName } = useSelector(
    (state) => state?.getAllHomeSectionsBySectionName
  );

    const { approveHomeSection } = useSelector((state) => state?.approveHomeSection);
  const { rejectHomeSection } = useSelector((state) => state?.rejectHomeSection);


  useEffect(() => {
    const fetchData = async () => {
      if (role === "superAdmin" || role === "management") {

        const data1 = {
          data: {

            section_name: "banner" // "Touch" , "getInTouch"
          },
          method: "post",
          apiName: `getAllHomeSectionsBySectionNameWithAllAuthUserDetails`,
        };

        const responseData = await dispatch(actions.GETALLHOMESECTIONSWITHCREATORBYSECTIONNAME(data1));
        setResponseTableData(responseData?.payload)

      }
      // else if (role === "management") {

      //   const data1 = {
      //     data: {

      //       section_name: "banner" // "Touch" , "getInTouch"
      //     },
      //     method: "post",
      //     apiName: `getAllHomeSectionsBySectionName`,
      //   };

      //   const responseData = await dispatch(actions.GETALLHOMESECTIONBYSECTIONNAME(data1));
      //   setResponseTableData(responseData?.payload)

      // }

      else {

        const data1 = {
          data: {
            section_name: "banner" // "Touch" , "getInTouch"

          },
          method: "post",
          apiName: `getAllHomeSectionsBySectionNameBasedOnCreator`,
        };

        const responseData = await dispatch(actions.GETALLAHOMESECTIONSBYSECTIONNAMEBASEDONCREATOR(data1));
        setResponseTableData(responseData?.payload)


      }
    }


    fetchData();
  }, [addHomeSectionPost,approveHomeSection,rejectHomeSection, addHomeSectionWithApproval, deleteHomeSection, updateHomeSection, updateHomeSectionForReApproval]);


  React.useEffect(() => {
    dispatch(setHeaderName("Content Management"));
    dispatch(setSubHeaderName("Home"));
  }, []);
  
  useEffect(() => {
    const tempArr = [];
    if (role === "superAdmin" || role === "management") {
      getAllHomeSectionsWithCreatorBySectionName?.data?.map((data, index) => {
        return tempArr.push({


          title: data?.heading || '--',
          secondtext: data?.sub_heading || '--',
          subtext: data?.content || '--',
          section_id: data?.section_id || '--',
          creatorName: data?.creator?.name || '--',
          creatorRole: data?.creatorRole?.roleName || '--',
          approverName: data?.approver?.name || '--',
          approverRole: data?.approverRole?.roleName || '--',
          rejectorName: data?.rejector?.name || '--',
          rejectorRole: data?.rejectorRole?.roleName || '--',
          // approval_status: data?.approval_status || "--"
          approval_status: data?.approval_status
            ? data.approval_status.charAt(0).toUpperCase() + data.approval_status.slice(1)
            : "--"
        });
      });
      setRowTableData(tempArr);
    }
    //  if (role === "management") {
    //   getAllHomeSectionsBySectionName?.data?.map((data, index) => {
    //     return tempArr.push({
    //       creatorName: data?.creator?.name || '--',
    //       creatorRole: data?.creatorRole?.roleName || '--',

    //       title: data?.heading || '--',
    //       secondtext: data?.sub_heading || '--',
    //       subtext: data?.content || '--',
    //       section_id: data?.section_id || '--',
    //       // approval_status: data?.approval_status || "--"
    //       approval_status: data?.approval_status
    //         ? data.approval_status.charAt(0).toUpperCase() + data.approval_status.slice(1)
    //         : "--"
    //     });
    //   });
    //   setRowTableData(tempArr);
    // }
    else {
      getAllHomeSectionsBySectionNameBasedOnCreator?.data?.map((data, index) => {
        return tempArr.push({

          title: data?.heading || '--',
          secondtext: data?.sub_heading || '--',
          subtext: data?.content || '--',
          section_id: data?.section_id || '--',
          // approval_status: data?.approval_status || "--"
          approval_status: data?.approval_status
            ? data.approval_status.charAt(0).toUpperCase() + data.approval_status.slice(1)
            : "--"

        });
      });
      setRowTableData(tempArr);

    }
  }, [getAllHomeSectionsBySectionNameBasedOnCreator, getAllHomeSectionsBySectionName, getAllHomeSectionsBySectionName, getAllHomeSectionsWithCreatorBySectionName]);


  console.log(rowTableData, "rowTableDatattattata")


  const handleTableDataDelete = async (id) => {


    const data1 = {
      data: {},
      method: "delete",
      apiName: `deleteHomeSection/${id}`,
    };
    const responseData = await dispatch(actions.DELETEHOMESECTION(data1));
    if (responseData?.payload?.message === "Home section soft deleted successfully.") {
      toast.success(responseData?.payload?.message)
    } else {
      toast.error(responseData?.payload?.message)

    }
  }


  return (
    <Grid container spacing={2}>

      <Grid item xs={12} sx={{ width: "100px" }}>

        <CustomTable
          // tableEdit="tableEdit"
          // tableDelete="tableDelete"

          tableData={rowTableData} title="Banner" tableHeadData={tableHeadData}
          modalName={BannerinputGetModal}
          editModalName={BannerinputGetModal}


          // const permissions = JSON.parse(sessionStorage.getItem("permissions"));
          tableView={true}
          modalVeiwName={PreviewComponent}
          ModalPreviewComponent1={LandingPage}
          tableDelete={permissions?.ContentManagement?.Home.delete}
          sectionNameForApproveAndReject="HomeSection"
          

          tableEdit={permissions?.ContentManagement?.Home.edit}
          dataCreate={permissions?.ContentManagement?.Home.add}
          handleTableDataDelete={handleTableDataDelete}
        />

      </Grid>
    </Grid>
  )
}

export default BannerHome